import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
    status: '',
    cumulativeCost: {},
    currentTrends: [],
    pastTrends: [],
    finalData: {
        estimated: [],
        past: []
    },
    months: [],
    regions: [],
    products: [],
    downloadLoading: false
}

export default {
    namespaced: true,
    state,
    actions,
    getters,
    mutations
}
